import { Form, Formik } from "formik";
import * as Yup from "yup";
import { FiUser } from "react-icons/fi";
import { Input } from "../../../components/Input";
import { Modal, ModalButton } from "../../../components/Modal";
import { api } from "../../../services/api";

interface ModalAddCostumerProps {
  setModalAddCostumer(showModal: boolean): void;
}

interface Costumer {
  newCostumer_name: string;
}

const schema = Yup.object().shape({
  newCostumer_name: Yup.string().required("Nome do cliente é obrigatório"),
});

export function ModalAddCostumer({
  setModalAddCostumer,
}: ModalAddCostumerProps) {
  const initialValues: Costumer = {
    newCostumer_name: "",
  };

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      validationSchema={schema}
      onSubmit={() => {
        // Submit handled by button onClick
      }}
    >
      {({ errors, values }) => (
        <Modal
          isOpen
          onClose={() => setModalAddCostumer(false)}
          title="Novo Cliente"
          icon={<FiUser size={24} />}
          variant="primary"
          footer={
            <>
              <ModalButton
                variant="cancel"
                onClick={() => setModalAddCostumer(false)}
              >
                Cancelar
              </ModalButton>
              <ModalButton
                variant="success"
                onClick={async () => {
                  if (!values.newCostumer_name) return;
                  await api.post("/costumers", {
                    name: values.newCostumer_name,
                    address: "",
                    number: "",
                    complement: "",
                    district: "",
                    city: "",
                    state: "",
                    zip: "",
                  });
                  setModalAddCostumer(false);
                }}
              >
                Salvar
              </ModalButton>
            </>
          }
        >
          <Form>
            <div className="space-y-4">
              <div>
                <span className="block text-sm font-medium text-gray-700 mb-1">
                  Nome do Cliente
                </span>
                <Input
                  type="text"
                  name="newCostumer_name"
                  placeholder="Digite o nome do cliente"
                  error={errors.newCostumer_name}
                  className="h-[52px] px-4 w-full rounded-lg text-[#7FA5B2] bg-white border border-gray-200 focus:border-[#0085BD] focus:ring-1 focus:ring-[#0085BD]"
                />
              </div>
            </div>
          </Form>
        </Modal>
      )}
    </Formik>
  );
}
